<!--制造MBOM-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form class="manufacture-search-form" @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          slot="organizationCode"
          :value.sync="queryParams.organizationCode"
          selectType="selectAssembleFilter"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :assembleLabel="true"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button v-hasPermi="['mdm:mbomBillStructures:edit']" type="primary" :loading="loading" @click="onUpdate">修改</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:diffDetail']" type="primary" :loading="loading" @click="onHandleDifference">与PBOM差异处理</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:export']" type="primary" :loading="loading" @click="handleExport">导出</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:importMbomBill']" type="primary" @click="importExcelHandleOpen">导入</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:mbomBillImportTemplate']" @click="importTemplate">导入模版</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:diffApply']" type="primary" :loading="loading" @click="onBatchDifference">批量处理差异</a-button>
        <a-button v-hasPermi="['mdm:mbomBillStructures:batchReplaceMateria']" @click="onBatchReplaceMaterial">批量替换物料</a-button>
        <!-- 批量替换物料弹窗 -->
        <replace-material-modal
          ref="replaceMaterialModal"
          @refresh="() => handleOk(true)"
        />
        <download-modal :apiFun="apiMbomBillStructuresExport" ref="download" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :expandIconColumnIndex="2"
          :expanded-row-keys.sync="expandedRowKeys"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :custom-selection="selectionConfig"
          :multi-select="true"
          @selectedRowChange="selectedRowChange"
          @successCallBack="successCallBack"
          :scroll="{ fixScreen: true, x: 1800 }">
          <template #itemCodeHeader>
            <span class="item-code-header">
              <a-icon
                :type="allExpanded ? 'minus-square' : 'plus-square'"
                class="expand-toggle-icon"
                @click="toggleExpandAll"
              />
              <span>物料编码</span>
            </span>
          </template>
          <template #operation="{ record }">
            <a v-hasPermi="['mdm:mbomBillStructures:log']" @click="() => handleLog(record)">日志</a>
          </template>
        </ls-api-table>
        <updateModal ref="updateModalRef" @refresh="() => handleOk(true)" />
        <difference-modal ref="differenceModalRef" @refresh="() => handleOk(true)" @update="onUpdate" />
        <batch-difference-modal ref="batchDifferenceModalRef" @refresh="() => handleOk(true)" />
        <operation-log-model ref="operationLogModelRef" :logLoading="logLoading" :logList="logList" @closeLog="closeLogFun" />
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="false"
            :headers="upload.headers"
            :action="upload.url"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import cacheSearch from '@/mixins/cacheSearch'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import updateModal from '@/views/mdm/matter/manufactureMbom/components/update-modal.vue'
import differenceModal from '@/views/mdm/matter/manufactureMbom/components/difference-modal.vue'
import BatchDifferenceModal from '@/views/mdm/matter/manufactureMbom/components/batch-difference-modal.vue'
import { apiMbomBillStructuresList, apiMbomBillStructuresLogList, apiMbomBillStructuresExport } from '@/api/mdm/matter/manufacture-mbom.js'
import OperationLogModel from '@/components/operation-log/operation-log-model.vue'
import { mapState } from 'vuex';
import { formList, columns } from '@/views/mdm/matter/manufactureMbom/enum'
import Cookies from 'js-cookie'
import ReplaceMaterialModal from './components/replace-material-modal'

export default {
  name: 'ManufactureMbom',
  components: { DownloadModal, updateModal, differenceModal, BatchDifferenceModal, OperationLogModel, ReplaceMaterialModal },
  mixins: [cacheSearch],
  data() {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiMbomBillStructuresExport,
      loading: false,
      excelVisible: false,
      upload: {
        title: '导入Excel',
        headers: { Authorization: Authorization },
        url: process.env.VUE_APP_API_BASE_URL + '/mdm/mbomBillStructures/importMbomBill'
      },
      logLoading: false, // 日志loading
      logList: [], // 日志列表
      selectedRowKeys: [],
      selectedRows: [],
      expandedRowKeys: [],
      allExpanded: false,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiMbomBillStructuresList, false),
        pageCurrent: true
      },

      dataList: [], // 当前列表数据
      firstLevelIds: [], // 一级节点id
      // 查询参数
      queryParams: {
        organizationCode: undefined,
        itemCode: undefined,
        itemCodes: undefined,
        mbomVersion: undefined,
        pbomVersion: undefined,
        modifyFlag: undefined,
        effectiveFlag: 'Y', // 默认为是
        createTime: undefined,
        createTimeFrom: undefined,
        createTimeTo: undefined,
        updateTime: undefined,
        updateTimeFrom: undefined,
        updateTimeTo: undefined,
        itemName: undefined,
        diffFlag: undefined
      },
      formList: formList,
      // 表格字段
      columns: columns,
      // 选择框配置
      selectionConfig: {
        getCheckboxProps: record => {
          return {
            props: {
              // 子级节点不可选
              disabled: !this.firstLevelIds.includes(record.id)
            }
          }
        }
      }
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created() {},
  mounted() {
    this.firstLevelIds = [];
    this.loading = false;
    this.$nextTick(() => {
      this.$refs.refSearchForm.form.setFieldsValue({ effectiveFlag: 'Y' })
      this.onSearch({ effectiveFlag: 'Y' })
    })
  },
  methods: {
    // 兼容处理excel复制的处理，去掉空格，整合成list
    onChangeCopyFormExcel(params, valField, listField) {
      const listVal = []
      if (params[valField]) {
        const list = params[valField].split(' ')
        list.forEach((v, i) => {
          list[i] = v.replace(/[\n\r\s]+/g, '')
          if (list[i]) { listVal.push(list[i]) }
        })
      }
      params[listField] = listVal
    },
    // 关闭日志弹窗
    closeLogFun() {
      this.logLoading = false;
      this.logList = [];
    },
    // 更新
    onUpdate() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      if(this.selectedRows?.length > 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      const getDafultRow = this.dataList.find(item => item.id === this.selectedRows[0].id)
      this.$refs.updateModalRef.show(getDafultRow)
    },
    onBatchReplaceMaterial() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      this.$refs.replaceMaterialModal.show({ list: this.selectedRows })
    },
    // 操作日志弹窗
    handleLog(row) {
      this.logList = []
      this.logLoading = true
      this.$refs.operationLogModelRef.show()
      apiMbomBillStructuresLogList({ orderId: row.id }).then(res => {
        if (res?.code === 200 && res?.rows?.length > 0) {
          res.rows.forEach(item => {
            item.logInfo = item.log
          })
          this.logList = res.rows
        }
      }).finally(() => {
        this.logLoading = false
      })
    },
    // 查询返回
    successCallBack(data) {
      this.dataList = data || [];
      this.firstLevelIds = data.map(item => item.id); // 一级节点id
      this.expandedRowKeys = [];
      this.allExpanded = false;
    },
    collectExpandedKeys(treeList = [], keys = []) {
      if (!Array.isArray(treeList) || !treeList.length) {
        return keys;
      }
      treeList.forEach(item => {
        if (Array.isArray(item.children) && item.children.length > 0) {
          if (item.id !== undefined && item.id !== null) {
            keys.push(item.id);
          }
          this.collectExpandedKeys(item.children, keys);
        }
      });
      return keys;
    },
    toggleExpandAll() {
      if (this.allExpanded) {
        this.expandedRowKeys = [];
        this.allExpanded = false;
        return;
      }
      this.expandedRowKeys = this.collectExpandedKeys(this.dataList, []);
      this.allExpanded = true;
    },
    // 差异
    onHandleDifference() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      if(this.selectedRows?.length > 1) {
        return this.$message.warning("请勾选一条单据进行操作")
      }
      if(this.selectedRows[0].diffFlag !== '1') {
        return this.$message.warning("请选择“与PBOM差异”为是数据")
      }
      this.$refs.differenceModalRef.show(this.selectedRows[0])
    },
    // 批量差异处理
    onBatchDifference() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      const invalidRows = this.selectedRows.filter(item => item.diffFlag !== '1')
      if(invalidRows.length > 0) {
        return this.$message.warning("请选择所有“与PBOM差异”都为是的数据")
      }
      this.$refs.batchDifferenceModalRef.show(this.selectedRows)
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    },
    // 下载导入模版
    importTemplate() {
      this.download('mdm/mbomBillStructures/mbomBillImportTemplate', {
        ...this.$refs.dataTable.searchParams
      }, `制造MBOM导入模版_${new Date().getTime()}.xlsx`)
    },
    // 打开导入弹窗
    importExcelHandleOpen() {
      this.excelVisible = true
    },
    // 关闭导入弹窗
    importExcelHandleCancel() {
      this.excelVisible = false
      this.handleOk(true)
    },
    // 导入文件状态变更
    importExcelHandleChange(info) {
      const status = info.file.status
      if (status === 'done') {
        if (info.file.response?.code === 200) {
          this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
        } else {
          this.$message.error(`${info.file.name}: ${info.file.response?.msg || '导入失败'}`)
        }
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response?.msg || '导入失败'}`)
      }
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch(value = {}, changePage = false) {
      const params = Object.assign({}, this.queryParams, value)
      this.onChangeCopyFormExcel(params, 'itemCode', 'itemCodes')
      delete params.searchFormLabel
      if(params?.itemCodes?.length === 1) {
        delete params.itemCodes
      }else {
        delete params.itemCode
      }
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData(changePage)
    },
    // 新增/修改框事件, changePage为true，则不返回到第一页
    handleOk(changePage = false) {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() }, changePage)
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {}
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    }
  }
}
</script>

<style scoped lang="less">
.item-code-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.expand-toggle-icon {
  color: #1890ff;
  cursor: pointer;
}

/deep/.manufacture-search-form .ant-col:nth-last-child(2) {
  .ant-form-item{
    .ant-form-item-label{
      width: 160px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 230px !important;
    }
  }
}
/deep/.manufacture-search-form .ant-col:nth-child(4) {
  .ant-form-item{
    .ant-form-item-label{
      width: 160px !important;
    }
    .ant-form-item-control-wrapper{
      max-width: 230px !important;
    }
  }
}
</style>
